import React, { useMemo } from 'react';
import { withTranslation } from 'react-i18next';
import TableContainer from '../Common/TableContainer';
import { formatBrazilDate } from '../../helpers/format';

const ImportsList = ({ imports, loading, pagination, t }) => {
  const getStatusBadge = (status) => {
    const statusMap = {
      pending: 'bg-warning-subtle text-warning',
      done: 'bg-success-subtle text-success',
      error: 'bg-danger-subtle text-danger',
    };
    return statusMap[status] || 'bg-secondary-subtle text-secondary';
  };

  const getStatusText = (status) => {
    const statusTexts = {
      pending: t('imports.status.pending', 'Pendente'),
      done: t('imports.status.done', 'Concluído'),
      error: t('imports.status.error', 'Erro'),
    };
    return statusTexts[status] || status;
  };

  const getIdentifierText = (identifier) => {
    const identifierTexts = {
      import_incentives: t('imports.types.incentives', 'Incentivos'),
      import_catalog: t('imports.types.catalog', 'Catálogo'),
      update_customers: t(
        'imports.types.update-customers',
        'Atualização de Clientes'
      ),
      import_customers: t(
        'imports.types.import-customers',
        'Importação de Clientes'
      ),
      import_product_strategy: t(
        'imports.types.product-strategy',
        'Estratégia de Produto'
      ),
      deactivate_users: t('imports.types.deactivate-users', 'Desativar Usuários'),
    };
    return identifierTexts[identifier] || identifier;
  };

  const columns = useMemo(
    () => [
      {
        Header: t('imports.table.id', 'ID'),
        accessor: 'id',
        Cell: (cellProps) => cellProps.row.original.id,
      },
      {
        Header: t('imports.table.total-rows', 'Total de Linhas'),
        accessor: 'total_rows',
        Cell: (cellProps) =>
          cellProps.row.original.total_rows?.toLocaleString('pt-BR') || '-',
      },
      {
        Header: t('imports.table.total-rows-with-error', 'Total de Linhas com Erro'),
        accessor: 'total_rows_with_error',
        Cell: (cellProps) =>
          cellProps.row.original.total_rows_with_error?.toLocaleString('pt-BR') || '-',
      },
      {
        Header: t('imports.table.status', 'Status'),
        accessor: 'status',
        Cell: (cellProps) => {
          const status = cellProps.row.original.status;
          return (
            <span className={`badge rounded-pill ${getStatusBadge(status)}`}>
              {getStatusText(status)}
            </span>
          );
        },
      },
      {
        Header: t('imports.table.type', 'Tipo'),
        accessor: 'identifier',
        Cell: (cellProps) =>
          getIdentifierText(cellProps.row.original.identifier),
      },
      {
        Header: t('imports.table.created-at'),
        accessor: 'created_at',
        Cell: (cellProps) => formatBrazilDate(cellProps.row.original.created_at),
      },
    ],
    [t]
  );

  return (
    <div className="imports-list">
      <TableContainer
        columns={columns}
        data={imports || []}
        isLoading={loading}
        activePage={pagination.current}
        pageSize={pagination.pageSize}
        totalPages={Math.ceil(pagination.total / pagination.pageSize)}
        setPage={pagination.onChange}
        count={pagination.total}
        t={t}
        theadClass="table-light"
        divClass="table-responsive table-card mb-0"
        tableClass="align-middle table-nowrap"
      />
    </div>
  );
};

export default withTranslation()(ImportsList);
